export const baseUrlsWS = {
  DEVELOPMENT: {
    USER_SERVICE: "https://user-api-qa.worksimpli.io",
    DOCBUILDER_SERVICE: "https://docbuilder-api-qa.worksimpli.io/api/v1/docbuilder/",
    DOCPARSER_SERVICE: "https://docbuilder-api-qa.worksimpli.io/api/v1/docparser/",
    EVENT_SERVICE: "https://event-api-qa.worksimpli.io",
    AUTH_SERVICE: "https://auth-qa.worksimpli.io/api/",
    META_CONTENT_SERVICE: "https://docmetacontent-api-qa.worksimpli.io/api/v1/",
    PAYMENT_SERVICE: "https://payment-api-qa.worksimpli.io/api/v1/",
    ORDER_SERVICE: "https://orderapi-qa.worksimpli.io/api/",
    PAYMENT_ORCHESTRATION_SERVICE: "https://paymentorchestration-qa.worksimpli.io/api/v1/",
    SINGLE_SIGN_ON_PDFSIMPLI: "https://test-app.pdfsimpli.com/sso/",
    SINGLE_SIGN_ON_SIGNSIMPLI: "https://test.signsimpli.com/sso/",
    SINGLE_SIGN_ON_WORKSIMPLI: "https://test.worksimpli.com/sso/",
    SINGLE_SIGN_ON_DASHBOARD: "https://test.worksimpli.com/app/",
    SIGNSIMPLI_URL: "https://test.signsimpli.com",
    PDFSIMPLI_URL: "https://test-app.pdfsimpli.com/",
    RESUMEBUILD_URL: "https://test.worksimpli.com/",
    WORKSIMPLI_URL: "https://test.worksimpli.com/",
    LEGALSIMPLI_URL: "https://test.legalsimpli.com/app",
    DASHBOARD_ORCH_SERVICE: "https://dashboardorch-qa.worksimpli.io",
    TRUSTPILOT_SERVICE: "",
    ABTEST_SERVICE: "https://abtest-api-qa.worksimpli.io",
    LEGALSIMPLI_URL: "https://test.legalsimpli.com/app",
    DOCOPERATION_SERVICE: "https://docoperation-api-qa.worksimpli.io/api/v1/",
    JOBMANGER_SERVICE: "https://jobmanager-api-qa.worksimpli.io/api/v1/",
    SIGNSIMPLI_ORCH: "https://signsimpli-orch-qa.worksimpli.io/api/v1/",
    DOC_EDITOR_SERVICE: "https://doceditor-api-qa.worksimpli.io/",
    DOC_PROFILE_SERVICE: "https://docprofile-api-qa.worksimpli.io/",
  },
  QA: {
    USER_SERVICE: "https://user-api-qa.worksimpli.io",
    DOCBUILDER_SERVICE: "https://docbuilder-api-qa.worksimpli.io/api/v1/docbuilder/",
    DOCPARSER_SERVICE: "https://docbuilder-api-qa.worksimpli.io/api/v1/docparser/",
    EVENT_SERVICE: "https://event-api-qa.worksimpli.io",
    AUTH_SERVICE: "https://auth-qa.worksimpli.io/api/",
    META_CONTENT_SERVICE: "https://docmetacontent-api-qa.worksimpli.io/api/v1/",
    PAYMENT_SERVICE: "https://payment-api-qa.worksimpli.io/api/v1/",
    ORDER_SERVICE: "https://orderapi-qa.worksimpli.io/api/",
    PAYMENT_ORCHESTRATION_SERVICE: "https://paymentorchestration-qa.worksimpli.io/api/v1/",
    SINGLE_SIGN_ON_PDFSIMPLI: "##PDFSimpli_SSO_BaseUrl##",
    SINGLE_SIGN_ON_SIGNSIMPLI: "##SignSimpli_SSO_BaseUrl##",
    SINGLE_SIGN_ON_WORKSIMPLI: "https://test.worksimpli.com/sso/",
    SINGLE_SIGN_ON_DASHBOARD: "##SignSimpli_Dashboard_BaseUrl##",
    SIGNSIMPLI_URL: "##SignSimpli_BaseUrl##",
    PDFSIMPLI_URL: "##PDFSimpli_BaseUrl##",
    RESUMEBUILD_URL: "##ResumeBuild_BaseUrl##",
    WORKSIMPLI_URL: "https://test.worksimpli.com/",
    LEGALSIMPLI_URL: "##LegalSimpli_BaseUrl##",
    DASHBOARD_ORCH_SERVICE: "https://dashboardorch-qa.worksimpli.io",
    TRUSTPILOT_SERVICE: "",
    ABTEST_SERVICE: "https://abtest-api-qa.worksimpli.io",
    LEGALSIMPLI_URL: "https://test.legalsimpli.com/app",
    DOCOPERATION_SERVICE: "https://docoperation-api-qa.worksimpli.io/api/v1/",
    JOBMANGER_SERVICE: "https://jobmanager-api-qa.worksimpli.io/api/v1/",
    SIGNSIMPLI_ORCH: "https://signsimpli-orch-qa.worksimpli.io/api/v1/",
    DOC_EDITOR_SERVICE: "https://doceditor-api-qa.worksimpli.io/",
    DOC_PROFILE_SERVICE: "https://docprofile-api-qa.worksimpli.io/",
  },
  STAGING: {
    USER_SERVICE: "https://user-api.worksimpli.io",
    DOCBUILDER_SERVICE: "https://docbuilder-api.worksimpli.io/api/v1/docbuilder/",
    DOCPARSER_SERVICE: "https://docbuilder-api.worksimpli.io/api/v1/docparser/",
    EVENT_SERVICE: "https://event-api.worksimpli.io",
    AUTH_SERVICE: "https://auth-api.worksimpli.io/api/",
    META_CONTENT_SERVICE: "https://docmetacontent-api.worksimpli.io/api/v1/",
    PAYMENT_SERVICE: "https://payment-api.worksimpli.io/api/v1/",
    ORDER_SERVICE: "https://order-api.worksimpli.io/api/",
    PAYMENT_ORCHESTRATION_SERVICE: "https://paymentorchestration-api.worksimpli.io/api/v1/",
    SINGLE_SIGN_ON_PDFSIMPLI: "https://pdfsimpli.com/sso/",
    SINGLE_SIGN_ON_SIGNSIMPLI: "https://signsimpli.com/sso/",
    SINGLE_SIGN_ON_WORKSIMPLI: "https://worksimpli.com/sso/",
    SINGLE_SIGN_ON_DASHBOARD: "https://staging.worksimpli.com/app/",
    RESUMEBUILD_URL: "https://staging.worksimpli.com/",
    SIGNSIMPLI_URL: "https://staging.signsimpli.com",
    PDFSIMPLI_URL: "https://staging.pdfsimpli.com/",
    WORKSIMPLI_URL: "https://staging.worksimpli.com/",
    LEGALSIMPLI_URL: "https://staging.legalsimpli.com/app",
    DASHBOARD_ORCH_SERVICE: "https://dashboardorch-api.worksimpli.io",
    TRUSTPILOT_SERVICE: "https://www.trustpilot.com/evaluate/embed/resumebuild.com",
    ABTEST_SERVICE: "https://abtest-api.worksimpli.io",
    LEGALSIMPLI_URL: "https://staging.legalsimpli.com/app/",
    DOCOPERATION_SERVICE: "https://docoperation-api.worksimpli.io/api/v1/",
    JOBMANGER_SERVICE: "https://jobmanager-api.worksimpli.io/api/v1/",
    SIGNSIMPLI_ORCH: "https://signsimpli-orch.worksimpli.io/api/v1/",
    DOC_EDITOR_SERVICE: "https://doceditor-api.worksimpli.io/",
    DOC_PROFILE_SERVICE: "https://docprofile-api.worksimpli.io/",
  },
  PRODUCTION: {
    USER_SERVICE: "https://user-api.worksimpli.io",
    DOCBUILDER_SERVICE: "https://docbuilder-api.worksimpli.io/api/v1/docbuilder/",
    DOCPARSER_SERVICE: "https://docbuilder-prod.azurewebsites.net/api/v1/docparser/",
    EVENT_SERVICE: "https://event-api.worksimpli.io",
    AUTH_SERVICE: "https://auth-api.worksimpli.io/api/",
    META_CONTENT_SERVICE: "https://docmetacontent-api.worksimpli.io/api/v1/",
    PAYMENT_SERVICE: "https://payment-api.worksimpli.io/api/v1/",
    ORDER_SERVICE: "https://order-api.worksimpli.io/api/",
    PAYMENT_ORCHESTRATION_SERVICE: "https://paymentorchestration-api.worksimpli.io/api/v1/",
    SINGLE_SIGN_ON_PDFSIMPLI: "https://pdfsimpli.com/sso/",
    SINGLE_SIGN_ON_SIGNSIMPLI: "https://signsimpli.com/sso/",
    SINGLE_SIGN_ON_WORKSIMPLI: "https://worksimpli.com/sso/",
    SINGLE_SIGN_ON_DASHBOARD: "https://worksimpli.com/app/",
    RESUMEBUILD_URL: "https://worksimpli.com/",
    SIGNSIMPLI_URL: "https://signsimpli.com",
    PDFSIMPLI_URL: "https://pdfsimpli.com/",
    WORKSIMPLI_URL: "https://worksimpli.com/",
    LEGALSIMPLI_URL: "https://legalsimpli.com/app",
    DASHBOARD_ORCH_SERVICE: "https://dashboardorch-api.worksimpli.io",
    TRUSTPILOT_SERVICE: "https://www.trustpilot.com/evaluate/embed/worksimpli.com",
    ABTEST_SERVICE: "https://abtest-api.worksimpli.io",
    LEGALSIMPLI_URL: "https://legalsimpli.com/app/",
    DOCOPERATION_SERVICE: "https://docoperation-api.worksimpli.io/api/v1/",
    JOBMANGER_SERVICE: "https://jobmanager-api.worksimpli.io/api/v1/",
    SIGNSIMPLI_ORCH: "https://signsimpli-orch.worksimpli.io/api/v1/",
    DOC_EDITOR_SERVICE: "https://doceditor-api.worksimpli.io/",
    DOC_PROFILE_SERVICE: "https://docprofile-api.worksimpli.io/",
  },
};

//export default baseUrls;

//export default baseUrls;
